import { useState } from 'react';
import { useDispatch } from 'react-redux';
import { DemoContainer } from '@mui/x-date-pickers/internals/demo';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { TimePicker } from '@mui/x-date-pickers/TimePicker';

// @mui
import { Link, Stack, IconButton, InputAdornment, TextField, Checkbox } from '@mui/material';
import { LoadingButton } from '@mui/lab';
import api from '../../../api';
import { loadingStartAction, loadingStopAction } from 'src/redux/actions/loadingActions';

// components

// ----------------------------------------------------------------------

export default function GameForm({ handleClose, selectedGame }) {
  const dispatch = useDispatch();
  // States for input fields
  const [gameName, setGameName] = useState(selectedGame?.game_name || '');
  const [openTime, setOpenTIme] = useState(null);
  const [closeTime, setCloseTime] = useState(null);

  const handleGameCreate = async () => {
    const reqBody = {
      game_name: gameName,
      open_time: openTime,
      close_time: closeTime,
      market_status: 'running',
      is_active: true,
    };

    dispatch(loadingStartAction());
    handleClose();
    try {
      if (selectedGame) {
        await api.put(`/master-games/${selectedGame._id}`, reqBody);
      } else {
        await api.post('/master-games', reqBody);
      }
      window.location.reload();
    } catch (error) {
      dispatch(loadingStartAction());
    }
  };

  return (
    <>
      <Stack spacing={3} my={2}>
        <TextField name="game_name" label="Game Name" value={gameName} onChange={(e) => setGameName(e.target.value)} />

        {/* {!selectedGame && ( */}
          <>
            <LocalizationProvider dateAdapter={AdapterDayjs}>
              <DemoContainer components={['TimePicker']}>
                <TimePicker label="Open Time" value={openTime} onChange={(newValue) => setOpenTIme(newValue)} />
              </DemoContainer>
            </LocalizationProvider>

            <LocalizationProvider dateAdapter={AdapterDayjs}>
              <DemoContainer components={['TimePicker']}>
                <TimePicker label="Close Time" value={closeTime} onChange={(newValue) => setCloseTime(newValue)} />
              </DemoContainer>
            </LocalizationProvider>
          </>
        {/* )} */}
      </Stack>

      <Stack direction="row" alignItems="center" justifyContent="space-between" sx={{ my: 2 }}>
        {/* <Checkbox
          name="remember"
          checked={rememberMe}
          onChange={(e) => setRememberMe(e.target.checked)}
          label="Remember me"
        /> */}
      </Stack>

      <LoadingButton fullWidth size="large" type="submit" variant="contained" onClick={handleGameCreate}>
        {selectedGame ? 'Update' : 'Create New'}
      </LoadingButton>
    </>
  );
}
